// auto-scale
export enum CardImageSize {
  SMALL = 50,
  MEDIUM = 100,
  LARGE = 145,
  MINI = 80,
}

// auto-scale
export enum CardSize {
  SMALL = 440,
  LARGE = 495,
  MINI = 250,
}
